import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { extracurricularsContent } from '../content';

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introductory section explaining what extracurricular activities are and why they matter for college admissions and personal growth.',
    detail: [
      extracurricularsContent.header.description.join('\n'),
      'Discussion questions:',
      ...extracurricularsContent.discussionQuestions.questions,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: extracurricularsContent.tools.title,
    description: 'Backrs tools to support building an extracurricular profile.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: extracurricularsContent.corePrinciples.title,
    description: 'Five core principles for building a strong activities profile.',
    detail: extracurricularsContent.corePrinciples.principles
      .map((p) => `${p.number}. ${p.title}: ${p.body}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: extracurricularsContent.mythsAndMistakes.title,
    description:
      'Common myths and mistakes students make when planning extracurricular activities.',
    detail: [
      extracurricularsContent.mythsAndMistakes.intro,
      ...extracurricularsContent.mythsAndMistakes.questions.map(
        (question) =>
          `${question.answer === 'myth' ? 'Myth' : 'Reality'}: ${question.statement} — ${question.feedback}`,
      ),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: extracurricularsContent.fourYearFramework.title,
    description:
      'A four-year framework covering exploration (9th), commitment (10th), leadership and impact (11th), and sustained excellence and reflection (12th).',
    detail: extracurricularsContent.fourYearFramework.years
      .map((y) => `${y.grade} — ${y.title}: ${y.points.join('; ')}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: extracurricularsContent.strategyByGoal.title,
    description:
      'Tailored activity strategies for different student paths: college-bound, career and technical education, and scholarship applicants.',
    detail: extracurricularsContent.strategyByGoal.paths
      .map(
        (path) =>
          `${path.label}: ${path.intro} ${path.moves
            .map((move) => `${move.title} — ${move.body}`)
            .join('; ')}`,
      )
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: extracurricularsContent.beforeYouApply.title,
    description:
      'Two habits for application season: keeping a running activity log, and knowing the story your activities list tells.',
    detail: extracurricularsContent.beforeYouApply.cards
      .map((card) =>
        [
          `${card.title}: ${card.body.join(' ')}`,
          ...card.items.map((item) => `${item.label} — ${item.text}`),
        ].join('\n'),
      )
      .join('\n'),
  });
};
